import { get } from "@services/apiService.js";

export default {
  getProducts(arrFilter) {
    return get(`/v4/product-web/v1/products`, arrFilter)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getBadges(lang) {
    return get(`/v4/product-web/v1/badges`, {language : lang})
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProductButtonContactSetting() {
    return get(`/v4/product-web/v1/products/button-contact-setting`)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProductCategoryName(params){
    return get(`/v4/product-web/v1/categories/${params.id}/name`, {language: params.language, level: params.level})
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProductBrandName(params){
    return get(`/v4/product-web/v1/brands/${params.id}/name`, {language: params.language})
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProductDetail(params) {
    return get(`/v4/product-web/v1/products/detail`, params)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProductDetailSku(params) {
    return get(`/v4/product-web/v1/products/detailSku`, params)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProductDetailAttribute(params) {
    return get(`/v4/product-web/v1/products/detail-attribute`, params)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getFilterProduct(params) {
    return get(`/v4/product-web/v1/filters`, params)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
  getProductCategory(params) {
    return get(`/v4/product-web/v1/categories`, params)
    .then(response => {
      return response.data || {};
    })
    .catch(error => {
      throw error;
    });
  },
}
